export const questions = [
    {
        question:"What happens if I add more team members to my plan?",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."
    },
    {
        question:"Can I cancel or switch at any time",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."
    },
    {
        question:"Does HostDesign have any time-limits or trials?",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."
        
    },
    {
        question:"How secure is HostDesign App?",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."

    },
    {
        question:"What payment methods does HostDesign accept?",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."

    },
    {
        question:"How do I purchase more than 6 team members?",
        answer:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."

    }
]